import { Link, useNavigate, useLocation } from "react-router-dom";
import { LogOut, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useSettings, assetUrl } from "@/lib/settings";

export default function Nav() {
  const nav = useNavigate();
  const loc = useLocation();
  const token = localStorage.getItem("ti_token");
  const { settings } = useSettings();
  const [open, setOpen] = useState(false);

  const logout = () => {
    localStorage.removeItem("ti_token");
    localStorage.removeItem("ti_user");
    nav("/");
  };

  const links = [
    { to: "/", label: "Beranda" },
    { to: "/marketplace", label: "Marketplace" },
    { to: "/chat", label: "AI Chat" },
    { to: "/register", label: "Daftar Pembeli" },
    { to: "/seller/register", label: "Jadi Seller" },
    { to: "/sales/register", label: "Sales Freelance" },
  ];
  if (token) links.push({ to: "/dashboard", label: "Dashboard" });

  const linkEl = (l) => (
    <Link
      key={l.to}
      to={l.to}
      onClick={() => setOpen(false)}
      data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
      className={`px-3 py-1.5 rounded-md text-sm font-medium transition ${
        loc.pathname === l.to ? "text-cyan-300 bg-cyan-500/10" : "text-slate-300 hover:text-cyan-200"
      }`}
    >{l.label}</Link>
  );

  return (
    <header className="sticky top-0 z-40 glass border-b border-cyan-500/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-2">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 shrink-0">
          {settings.logo_url ? (
            <img src={assetUrl(settings.logo_url)} alt="tokoinduk" className="h-9 sm:h-10 object-contain" />
          ) : (
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-cyan-400 to-blue-600 pulse-glow"/>
          )}
        </Link>

        <nav className="hidden xl:flex items-center gap-1">
          {links.map(linkEl)}
        </nav>

        <div className="flex items-center gap-2">
          {!token ? (
            <>
              <Button data-testid="nav-login-btn" variant="ghost" size="sm" onClick={() => nav("/login")} className="hidden sm:inline-flex text-slate-200 hover:text-cyan-300">Login Akun</Button>
              <Button data-testid="nav-register-btn" size="sm" onClick={() => nav("/register")} className="bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold hidden sm:inline-flex">Daftar Pembeli</Button>
            </>
          ) : (
            <Button data-testid="nav-logout-btn" variant="ghost" size="sm" onClick={logout} className="text-slate-200 hover:text-red-400">
              <LogOut className="w-4 h-4 sm:mr-1"/><span className="hidden sm:inline">Keluar</span>
            </Button>
          )}
          <button data-testid="nav-menu-toggle" className="xl:hidden text-slate-200 p-2" onClick={() => setOpen(!open)}>
            {open ? <X className="w-5 h-5"/> : <Menu className="w-5 h-5"/>}
          </button>
        </div>
      </div>

      {open && (
        <div className="xl:hidden border-t border-cyan-500/10 bg-slate-950/95 backdrop-blur">
          <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col gap-1">
            {links.map(linkEl)}
            {!token && (
              <Button data-testid="nav-mobile-login" size="sm" onClick={() => { setOpen(false); nav("/login"); }} variant="outline" className="mt-2 border-cyan-500/40 text-cyan-300">Login Akun</Button>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
